/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'
import { Popup } from 'semantic-ui-react'

import TabButton from './TabButton'

const Wrapper = styled.div`
  background-color: rgba(128, 128, 128, 0.7);
  padding: 2px 0px;
  display: flex;
  flex-direction: row;
  max-width: 100vw;
  z-index: 98;

  .pop-up {
    border-radius: 3px;
    opacity: 0.85;
    padding: 0.7em;
    font-weight: bold;
  }
`

@withRouter
class OpenedWindows extends React.Component {
  handleClose = (uriToClose) => {
    this.props.onRemoveWindowRequest({ id: uriToClose })
  }

  handleOpen = (uri) => {
    // const type = uri.split('/')[2]
    //   ? uri
    //       .split('/')[2]
    //       .charAt(0)
    //       .toUpperCase() + uri.split('/')[2].slice(1)
    //   : undefined

    // const searchID = uri.split('/')[3] ? uri.split('/')[3] : undefined

    // const tabs = this.props.tabsSlider[`${type}-${searchID}-Details`]

    // if (tabs) {
    //   const activeTabID = tabs.list.findIndex(item => item.name === tabs.activeTab)

    //   return this.props.history.push(`${uri}?tab=${parseFloat(activeTabID) + parseFloat(1)}`)
    // }

    return this.props.history.push(uri)
  }

  render() {
    const { activeWindow, list, order } = this.props
    const type = window.location.hash.split('/')[2]
      ? window.location.hash.split('/')[2].charAt(0).toUpperCase() + window.location.hash.split('/')[2].slice(1)
      : undefined

    const searchID = !window.location.hash.split('/')[3] ? undefined : window.location.hash.split('/')[3]

    if (
      this.props.DetailsContainerData[type] &&
      this.props.DetailsContainerData[type][searchID] &&
      (this.props.DetailsContainerData[type][searchID].data.base === false ||
        this.props.DetailsContainerData[type][searchID].data.view === false ||
        this.props.DetailsContainerData[type][searchID].data.viewconv === false)
    ) {
      this.handleClose(window.location.hash.substring(1))
    }

    if (order.length === 0) {
      return null
    }

    return (
      <Wrapper>
        {order.map((uri) => {
          const { name } = list[uri]

          return (
            <Popup
              key={uri}
              trigger={
                <TabButton
                  name={name}
                  icon={list[uri].icon}
                  shortName={list[uri].shortName}
                  active={uri === activeWindow}
                  uri={uri}
                  onOpen={() => this.handleOpen(uri)}
                  onClose={() => this.handleClose(uri)}
                />
              }
              on="hover"
              content={name}
              className="pop-up"
            />
          )
        })}
      </Wrapper>
    )
  }
}

export default OpenedWindows
